import PropTypes from 'prop-types';
import { personalize } from '../../../../../common/services/personalize/service';

export const name = 'personalize';
export const propType = PropTypes.object;
export const defaultProp = null;
export const onParse = personalize;
